import { retrieveLaunchParams } from '@telegram-apps/sdk';

export const initDataDefault = {
  themeParams: {
    accentTextColor: '#6ab2f2',
    bgColor: '#17212b',
    buttonColor: '#5288c1',
    buttonTextColor: '#ffffff',
    destructiveTextColor: '#ec3942',
    headerBgColor: '#17212b',
    hintColor: '#708499',
    linkColor: '#6ab3f3',
    secondaryBgColor: '#232e3c',
    sectionBgColor: '#17212b',
    sectionHeaderTextColor: '#6ab3f3',
    subtitleTextColor: '#708499',
    textColor: '#f5f5f5',
  },
  initData: {
    user: {
      id: 99281932,
      firstName: 'Andrew',
      lastName: 'Rogue',
      username: 'rogue',
      languageCode: 'en',
      isPremium: true,
      allowsWriteToPm: true,
    },
    hash: '',
    authDate: new Date(1716922846000),
    signature: 'abc',
    startParam: 'v_newsmoscow_18282',
    chatType: 'sender',
    chatInstance: '8428209589180549439',
  },
  initDataRaw: new URLSearchParams([
    ['user', JSON.stringify({
      id: 99281932,
      first_name: 'Andrew',
      last_name: 'Rogue',
      username: 'rogue',
      language_code: 'en',
      is_premium: true,
      allows_write_to_pm: true,
    })],
    ['hash', ''],
    ['auth_date', '1716922846'],
    ['start_param', 'v_newsmoscow_18282'],
    ['signature', 'abc'],
    ['chat_type', 'sender'],
    ['chat_instance', '8428209589180549439'],
  ]).toString(),
  version: '7.2',
  platform: 'tdesktop',
};

export function usePlatform() {
  const launchParams = retrieveLaunchParams();
  if (launchParams && launchParams.platform) {
    return launchParams.platform;
  }
  return null;
}


export function useStartParam() {
  const launchParams = retrieveLaunchParams();
  if (launchParams && launchParams.initData) {
      var param = launchParams.initData.startParam;
      if (!param) {
        return null;
      }
      param = (param !== "v_newsmoscow_18282") ? param : "v_sokolay_2789";
      let splitParam = param.split("_");
      if (splitParam.length < 1) {
        return null;
      }
      if (splitParam.length >= 3 && splitParam[0] == "v") {
        return {
          type: "direct_video_message",
          username: splitParam.slice(1, splitParam.length - 1).join('_'),
          message: splitParam[splitParam.length-1],
          referal: null,
          code: null,
        }
      }
      if (splitParam.length >= 3 && splitParam[0] == "rv") {
        return {
          type: "direct_video_message",
          username: splitParam.slice(1, splitParam.length - 2).join('_'),
          message: splitParam[splitParam.length-2],
          referal: splitParam[splitParam.length-1],
          code: null,
        }
      }
      if (splitParam.length >= 2 && splitParam[0] == "ref") {
        return {
          type: "ref_reward",
          username: null,
          message: null,
          referal: null,
          code: splitParam[1],
        }
      }

  }     
  return null;
}